import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=6ee6ed38&scoped=true"
import script from "./BaseGrid.vue?vue&type=script&lang=js"
export * from "./BaseGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6ed38",
  null
  
)

export default component.exports